import { render, staticRenderFns } from "./ToDoDeadlineComponent.vue?vue&type=template&id=d64a0350&scoped=true"
import script from "./ToDoDeadlineComponent.vue?vue&type=script&lang=ts"
export * from "./ToDoDeadlineComponent.vue?vue&type=script&lang=ts"
import style0 from "./ToDoDeadlineComponent.vue?vue&type=style&index=0&id=d64a0350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64a0350",
  null
  
)

export default component.exports